<template>
  <SelectBase
    v-model:searchQuery="modelSearch"
    :is-loading="isLoading"
    :is-disabled="isDisabled"
    :is-multiple="isMultiple"
    :is-searchable="isSearchable"
    :options="available"
    :placeholder="placeholder"
    :selected="selected"
    @deselect="onDeselect"
    @select="onSelect"/>
</template>

<script setup lang="ts">
import { toRef } from 'vue'
import { useFormSelect } from '@/composables'
import { SelectBase } from '@component/Miscellaneous'
import type { FormSelectOption, FormSelectValue } from '@/interfaces'

const modelSearch = defineModel<string>("searchQuery", {
  default: ""
});

const modelValue = defineModel<FormSelectValue>({
  required: true
});

const { options, isMultiple } = defineProps<{
  readonly placeholder: string;
  readonly isLoading?: boolean;
  readonly isDisabled?: boolean;
  readonly isMultiple?: boolean;
  readonly isSearchable?: boolean;
  readonly options: FormSelectOption[];
}>();

const { selected, available, values } = useFormSelect(modelValue, toRef(() => options), modelSearch, isMultiple);

function onDeselect(id: string|number|null): void {
  if (!isMultiple) return;

  modelValue.value = values.value.filter(value => value !== id);
}

function onSelect(id: string|number|null): void {
  modelValue.value = isMultiple ? [...values.value, id] : id;
}
</script>